export class LocationError extends Error {
  constructor(
    message: string,
    public code: string,
    public originalError?: unknown
  ) {
    super(message);
    this.name = 'LocationError';
  }
}

export function handleLocationError(error: unknown): LocationError {
  if (error instanceof LocationError) {
    return error;
  }

  if (error instanceof GeolocationPositionError) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        return new LocationError('Location permission denied', 'PERMISSION_DENIED', error);
      case error.POSITION_UNAVAILABLE:
        return new LocationError('Location information unavailable', 'POSITION_UNAVAILABLE', error);
      case error.TIMEOUT:
        return new LocationError('Location request timed out', 'TIMEOUT', error);
    }
  }

  return new LocationError(
    error instanceof Error ? error.message : 'Unknown location error',
    'UNKNOWN_ERROR',
    error
  );
}